import React from 'react';
import './RefundExchangeInfo.scss';

function RefundExchangeInfo(props) {
  const {
    dataLocale: { AS, PS, EXCHANGE_REFUND, TO_EXCHANGE_PRODUCTS_DOWNLOAD_APP },
  } = props;
  return (
    <div className="infoContainer display-flex margin-b40" data-testid="exchangeRefundInfo">
      <div className="message">
        <div className="title fw700">{EXCHANGE_REFUND}</div>
        <div>{TO_EXCHANGE_PRODUCTS_DOWNLOAD_APP}</div>
      </div>
      <div className="appBtns display-flex">
        <a href="https://onelink.to/lenskart2">
          <img
            alt={AS}
            src="https://static.lenskart.com/media/desktop/img/site-images/applestore.svg"
          />
        </a>
        <a href="https://onelink.to/lenskart2">
          <img
            alt={PS}
            src="https://static.lenskart.com/media/desktop/img/site-images/googleplay.svg"
          />
        </a>
      </div>
    </div>
  );
}

export default RefundExchangeInfo;
